import type React from 'react'
import { useRef } from 'react'

import css from './Input.module.scss'

type Props = {
  error: string
  loading: boolean

  onChange: (value: string) => void
}

const Input: React.FC<Props> = (props) => {
  const ref = useRef<HTMLTextAreaElement>(null)

  const onClickLabel = () => {
    if (ref.current) {
      ref.current.focus()
    }
  }

  const onChange = () => {
    const textarea = ref.current as HTMLTextAreaElement

    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight + 4}px`

    props.onChange(textarea.value)
  }

  return (
    <div className={css.container}>
      <div className={css.label} onClick={onClickLabel}>
        Paste Figma artboard URL here:
      </div>

      <textarea
        className={css.input}
        rows={1}
        ref={ref}
        onChange={onChange}
        disabled={props.loading}
      />

      {props.error && <div className={css.error}>{props.error}</div>}
    </div>
  )
}

export default Input
